// extracted by mini-css-extract-plugin
module.exports = {"volume":"Volume_volume__BZ5Xw","volumeInputs":"Volume_volumeInputs__2_Hll","sup":"Volume_sup__i_X_A"};